import { useEffect } from 'react';
import { ref, getDownloadURL } from 'firebase/storage';
import { storage } from '../../lib/firebase';
import { useBrandingStore } from '../../store/brandingStore';
import { logger } from '../../utils/logger';

import { getRestaurantId } from '../../utils/restaurant';

export const useBrandingInit = () => {
  const { setLogoUrl } = useBrandingStore();

  useEffect(() => {
    let cancelled = false;

    const loadLogo = async () => {
      const restaurantId = getRestaurantId();
      const cacheKey = `biteos_brand_logo_${restaurantId}`;
      const cachedLogo = window.localStorage.getItem(cacheKey);
      if (cachedLogo) {
        if (!cancelled) setLogoUrl(cachedLogo);
        return;
      }
      const setFallbackLogo = () => {
        if (!cancelled) {
          setLogoUrl('/logo.png');
          window.localStorage.setItem(cacheKey, '/logo.png');
        }
      };

      try {
        const logoRef = ref(storage, `restaurants/${restaurantId}/branding/logo.png`);
        const url = await getDownloadURL(logoRef);
        if (cancelled) return;
        setLogoUrl(url);
        window.localStorage.setItem(cacheKey, url);
        logger.info('Logo loaded successfully from Firebase');
      } catch (error) {
        try {
          const legacyLogoRef = ref(storage, 'branding/logo.png');
          const legacyUrl = await getDownloadURL(legacyLogoRef);
          if (cancelled) return;
          setLogoUrl(legacyUrl);
          window.localStorage.setItem(cacheKey, legacyUrl);
          logger.info('Logo loaded successfully from legacy Firebase path');
        } catch (legacyError) {
          logger.info('Logo not found in Firebase, using local fallback');
          setFallbackLogo();
        }
      }
    };

    loadLogo();

    return () => {
      cancelled = true;
    };
  }, [setLogoUrl]);
};
